import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Building } from "./building.model";
import { UserService } from "../../_services";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class BuildingService {
  building: Building = new Building();
  buildings: Building[] = [];

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) { }

  getBuildings() {
    return this.http.get<Building[]>(url + "buildings");
  }

  getBuilding(id: number) {
    return this.http.get<Building>(url + "buildings/" + id);
  }

  getBuildingName(buildingId: number) {
    if (this.buildings.length > 0) {
      return this.buildings.find((b) => b.id === buildingId)?.name;
    }
  }

  createBuilding(buildingDetails) {
    return this.http.post(url + "buildings", buildingDetails);
  }

  updateBuilding(buildingId, buildingDetails) {
    return this.http.put(url + "buildings/" + buildingId, buildingDetails);
  }

  deleteBuilding(id: number) {
    return this.http.delete(url + "buildings/" + id);
  }

  async getBuildingSync(id: number): Promise<Building> {
    return await this.http
      .get<Building>(environment.api + "buildings/" + id)
      .toPromise();
  }

  findBuilding(BuildingId: number) {
    if (this.buildings.length > 0) {
      return this.buildings.find((b) => b.id === BuildingId);
    }

    return null;
  }

  loadBuildings(reload: boolean = false) {
    if (this.buildings.length === 0 || reload) {
      this.getBuildings().subscribe((buildings: Building[]) => {
        this.buildings = [];
        buildings.forEach((el) => {
          delete el.image;
          this.buildings.push(el);
        });
      });
    }
  }

  //przykaład load w serwsie
  async loadBuildingsSync(reload: boolean = false) {
    if (this.buildings.length === 0 || reload) {
      return this.getBuildings()
        .toPromise()
        .then((list: Building[]) => {
          this.buildings = list;
        });
    }
  }

  async getUserBuilding(): Promise<Building> {
    await this.loadBuildingsSync();

    if (this.userService.userStorage.idBuilding) {
      return this.findBuilding(this.userService.userStorage.idBuilding);
    } else {
      if (this.buildings.length > 0) {
        return this.buildings[0];
      }
    }
  }

}
